module.exports = __webpack_public_path__ + "img/mobile-54.480112e7.png";